module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-26.ccb11c8.woff2";